export default __webpack_public_path__ + "static/media/warning.80eaf005.svg";